<div class="reports--master-container">
	<h1 class="center-text">Report Center</h1>
	<div *ngIf="!url; else closeBtn" class="center-text">
		<h2 class="center-text">Select a Report</h2>
		<select class="reports--report-select" (change)="navTo($event.target.value)">
			<option value=""></option>
			<option value="content/wrong-answer">Wrong Answer Report</option>
			<option value="venues/player-report">Players By Venue Report</option>
			<option value="workers/inactive-report">Inactive Workers Report</option>
  		<option value="venues/scratch-paper">Venues Low on Scratch Paper</option>
      <option value="workers/user-stats-report">Host Stats report</option>
  		<!-- <option value="venues/historical-cancellations">Venues Historical Cancellations</option>
      <option value="venues/health-report">Venue Health Report</option> -->
		</select>
	</div>

	<div class="reports--report-container">
		<router-outlet></router-outlet>
	</div>
</div>

<ng-template #closeBtn>
	<button (click)="navTo('')" class="sm-btn-red">Change Reports</button>
</ng-template>
